/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/prefer-default-export */
import { AxiosResponse } from 'axios';
import { AppDispatch } from '../Store';
import { getCurrencyRestrictionsURL } from '../endpoints';
import {
	CurrencyRestrictionsType,
	SetCurrencyRestrictionsAction,
} from './CurrencyRestrictionsTypes';
import axiosInstance from '../../helpers/axiosInstance';

export const getCurrencyRestrictions = (currencyCodes: string) => (dispatch: AppDispatch) => {
	return axiosInstance
		.get(getCurrencyRestrictionsURL(currencyCodes))
		.then(({ data }: AxiosResponse) => {
			return dispatch<SetCurrencyRestrictionsAction>({
				type: CurrencyRestrictionsType.SET_CURRENCY_RESTRICTIONS,
				data,
			});
		});
};
